enum ICON_STYLE {
    SOLID = 'Solid',
    OUTLINED = 'Outlined',
}

export { ICON_STYLE };
